import { useThemeSlice, StatusBadge } from "../ui/StatusBadge.jsx";

export function EntityTable({ columns, rows, renderCell }) {
  const { c, accentHex } = useThemeSlice();
  return (
    <div style={{ flex: 1, overflow: "auto", padding: "0 20px 20px" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th
                key={col.key}
                style={{
                  textAlign: "left",
                  padding: "10px 12px",
                  color: c.sub,
                  fontWeight: 600,
                  fontSize: 11,
                  letterSpacing: "0.06em",
                  textTransform: "uppercase",
                  borderBottom: `1px solid ${c.divider}`,
                  position: "sticky",
                  top: 0,
                  background: c.bg,
                }}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <EntityTableRow key={row.id} row={row} columns={columns} renderCell={renderCell} colors={c} accent={accentHex} />
          ))}
        </tbody>
      </table>
    </div>
  );
}

function EntityTableRow({ row, columns, renderCell, colors, accent }) {
  return (
    <tr
      onMouseEnter={(e) => (e.currentTarget.style.background = colors.hover)}
      onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
      style={{ transition: "background .15s" }}
    >
      {columns.map((col) => (
        <td key={col.key} style={{ padding: "11px 12px", borderBottom: `1px solid ${colors.divider}`, color: colors.text }}>
          {renderCell ? renderCell(row, col.key) : col.key === "status" ? <StatusBadge label={row.status} colors={colors} accent={accent} /> : row[col.key]}
        </td>
      ))}
    </tr>
  );
}
